import { useEffect, useRef } from "react";
import ProgressBar from "../components/ProgressBar";

export default function ResultPageNarcissism() {
    const storedScore = parseInt(localStorage.getItem('narcissismScore'), 10);
    const score = Number.isNaN(storedScore) ? 0 : storedScore;
    const total = 16;
    const wrapperRef = useRef();
    const lastSentHeight = useRef(0);

    const getResultText = (score) => {
        if (score < 3) {
            return (<><h3>Väldigt låg nivå av narcissistiska drag</h3><p>Dina svar på detta test indikerar att du upplever få eller inga symtom som är förknippade med narcissism. Det är ej sannolikt att narcissistiska drag föreligger.</p></>);
        } else if (score <= 4) {
            return (<><h3>Låg till genomsnittlig nivå</h3><p>Dina svar på detta test indikerar att du upplever några symtom som är förknippade med narcissism. Det är dock inte säkert att narcissistiska drag är orsaken till de symtom som du upplever, och dessa symtom förekommer även hos personer utan narcissism i varierande frekvens.</p></>);
        } else if (score >= 8 && score <= 11 ) {
            return (<><h3>Förhöjd nivå</h3><p>Dina svar på detta test indikerar att du upplever många av de symtom som är förknippade med narcissism. Det är dock inte säkert att narcissistiska drag är orsaken till de symtom som du upplever.</p></>);
        } else {
            return (<><h3>Hög nivå av narcissistiska drag</h3><br /><p>Dina svar tyder på många narcissistiska drag. Kontakta en specialist för vidare utredning.</p></>);
        }
    }
    useEffect(() => {
        const savedScore = localStorage.getItem('narcissismScore');
        if (!score) {
            if (savedScore) {
                localStorage.removeItem('narcissismScore');
            }
        }

        if (savedScore) {
            localStorage.removeItem('narcissismScore');
        }

        const observer = new ResizeObserver(() => {
                const height = wrapperRef.current?.scrollHeight;
                if (height && Math.abs(height - lastSentHeight.current) > 20) {
                    window.parent.postMessage(
                        { type: "setHeight", height: height },
                        "*"
                    );
                    lastSentHeight.current = height;
                }
            });
        window.parent.postMessage(
            { type: "quizCompleted", test: "narcissism_quiz" },
            "*"
        );

        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return () => observer.disconnect();
    }, [score]);

    return (
        <div ref={wrapperRef} className="questionnaire-adhd">
            <div className="results">
                <h2>Resultat</h2>
                <ProgressBar current={score} total={total} />
                {getResultText(score)}
                <h3>Kom ihåg</h3>
                <ul className="results-reminder">
                    <li>Ett testresultat är inte samma sak som en diagnos.</li>
                    <li>Resultatet är vägledande och behöver alltid tolkas i ett större sammanhang.</li>
                    <li>Om du upplever att detta påverkar ditt mående bör du söka professionell hjälp.</li>
                </ul>
            </div>
        </div>
    );
}